module.exports = __webpack_public_path__ + "static/Street Pharmacy - Village Douala-438c297022dc7d89345fdc89acd605a1.jpg";